import { call, ForkEffect, put, takeLeading } from "redux-saga/effects";
import { ALERTS } from "../../redux/alerts/types";
import {
  getFeedbackByAlertTypeFailure,
  getFeedbackByAlertTypeSuccess,
  setAlertByTypeFailure,
  setAlertByTypeSuccess,
} from "../../redux/modalFeedback/actions";
import {
  IGetFeedbackByTypeAlertRequest,
  ISetAlertByTypeRequest,
} from "../../redux/modalFeedback/types";
import { notificationCongrat } from "../../redux/newNotification/actions";
import { NotificationState } from "../../redux/newNotification/types";
import { hidePreloader, showPreloader } from "../../redux/preloader/actions";
import { AxiosCustom } from "../../service/Axios";

export function* getFeedbackByAlertTypeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    ALERTS.GET_FEEDBACK_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST,
    getFeedbackByAlertTypeSaga
  );
}

export function* setAlertByTypeWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLeading(
    ALERTS.SET_ALERTS_BY_ALERT_TYPE_AND_RESIDENT_ID_REQUEST,
    setAlertByTypeSaga
  );
}

function* getFeedbackByAlertTypeSaga(action: IGetFeedbackByTypeAlertRequest) {
  try {
    const result = yield call(() =>
      AxiosCustom.getFeedbackByAlertType(action.payload)
    );
    yield put(getFeedbackByAlertTypeSuccess({ ...result.data }));
  } catch (error) {
    yield put(getFeedbackByAlertTypeFailure(error));
  }
}

function* setAlertByTypeSaga(action: ISetAlertByTypeRequest) {
  const { residentId, alertToken } = action.payload;
  try {
    yield put(showPreloader());
    yield call(() => AxiosCustom.setAlertByType(action.payload));
    yield put(
      setAlertByTypeSuccess({ patientId: residentId, alertId: alertToken })
    );
    yield put(hidePreloader());
    yield put(
      notificationCongrat({
        residentId: action.payload.residentId,
        type: action.payload.alertToken,
        state: NotificationState.congrat,
      })
    );
  } catch (error) {
    yield put(hidePreloader());

    yield put(setAlertByTypeFailure(error));
  }
}
